import api from "Helpers/Api";

export default async function getBoletinsCategories() {
  const { data } = await api.get<string[]>("/boletins/categories");

  return data;
}
